export const GET_TEAM_MEMBERS_SUCCESS = 'GET_TEAM_MEMBERS_SUCCESS';
export const DELETE_TEAM_MEMBER_SUCCESS = 'DELETE_TEAM_MEMBER_SUCCESS';
export const SET_FETCHING_TEAM_MEMBERS = 'SET_FETCHING_TEAM_MEMBERS';